var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadingInfoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.83333H12.8333V8.16667H10.5V5.83333ZM10.5 10.5H12.8333V17.5H10.5V10.5ZM11.6667 0C5.22667 0 0 5.22667 0 11.6667C0 18.1067 5.22667 23.3333 11.6667 23.3333C18.1067 23.3333 23.3333 18.1067 23.3333 11.6667C23.3333 5.22667 18.1067 0 11.6667 0ZM11.6667 21C6.52167 21 2.33333 16.8117 2.33333 11.6667C2.33333 6.52167 6.52167 2.33333 11.6667 2.33333C16.8117 2.33333 21 6.52167 21 11.6667C21 16.8117 16.8117 21 11.6667 21Z",
    fill: "#CB3D47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadingInfoOutline);
export default __webpack_public_path__ + "static/media/heading_info_outline.8abe1d773bd1d86241a1b0088190cf5a.svg";
export { ForwardRef as ReactComponent };